import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";


const Form_SB_08 = ({matterContacts, selectedMatter, selectedForm, xfaCombinedData, setXfaCombinedData, xfaGeneratedForm, modify}) => {
    const initialState = {
        certificationStatement: {
            isSection156: false,
            isNotSection156: false
        },
        othersSection: {
            attachedCertification: false,
            feeSubmitted: false,
            certificationNotSubmitted: false
        },
    };

    const [state, setState] = useState(initialState);

    const {
        certificationStatement: {isSection156, isNotSection156},
        othersSection: {attachedCertification, feeSubmitted, certificationNotSubmitted}
    } = state || initialState;

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

        if (modify) {
            if (selectedItem) {
                if (xfaGeneratedForm?.statusCode === 500) {
                    toast.error("Failed to preview the form");
                } else {
                    selectedItem.data = xfaGeneratedForm;
                    setState(xfaGeneratedForm);
                }
            }
        }
    }, []);

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);
        if (selectedItem?.data) {
            setState(selectedItem.data);
        } else {
            setState(initialState);
        }
    }, [selectedMatter, selectedForm]);

    useEffect(() => {
        setXfaCombinedData && setXfaCombinedData(previousData => {
            const newData = JSON.parse(JSON.stringify(previousData));

            const item = newData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

            if (item) {
                if (!item.data) {
                    item.data = {};
                }
                item.data = state;
            }

            return newData;
        });
    }, [state]);

    const useStyles = makeStyles({
        smallRadio: {
            "& svg": {
                width: 20,
                height: 20
            },
            "& svg > circle": {
                width: 12,
                height: 12
            }
        },
        smallCheckbox: {
            "& svg": {
                width: 20,
                height: 20
            }
        },
        table: {
            border: "1px solid black"
        },
        row: {
            "&:nth-of-type(odd)": {
                backgroundColor: "#F5F5F5"
            },
            "&:nth-of-type(even)": {
                backgroundColor: "white"
            }
        }
    });

    const classes = useStyles();

    const handleChange = event => {
        let {name, type, checked, value} = event.target;
        const [mainKey, subKey] = name.split(".");

        if (subKey) {
            if (subKey === "isNotSection156" || subKey === "isSection156") {
                setState(prevState => ({
                    ...prevState,
                    [mainKey]: {
                        ...prevState[mainKey],
                        isNotSection156: checked ? subKey === "isNotSection156" : false,
                        isSection156: checked ? subKey === "isSection156" : false
                    }
                }));
            } else {
                setState(prevState => ({
                    ...prevState,
                    [mainKey]: {
                        ...prevState[mainKey],
                        [subKey]: type === "checkbox" ? checked : value
                    }
                }));
            }
        } else {
            if (name !== "signatories") {
                setState(prevState => ({
                    ...prevState,
                    [name]: type === "checkbox" ? checked : value
                }));
            }
        }
    };

    const certificationLabel1 = "That each item of information contained in the information disclosure statement was first cited in any communication from a foreign patent office in a counterpart foreign application not more than three months prior to the filing of the information disclosure statement. See 37 CFR 1.97(e)(1).";
    const certificationLabel2 = "That no item of information contained in the information disclosure statement was cited in a communication from a foreign patent office in a counterpart foreign application, and, to the knowledge of the person signing the certification after making reasonable inquiry, no item of information contained in the information disclosure statement was known to any individual designated in 37 CFR 1.56(c) more than three months prior to the filing of the information disclosure statement. See 37 CFR 1.97(e)(2).";

    const othersLabel1 = "See attached certification statement.";
    const othersLabel2 = "The fee set worth in 37 CFR 1.17 (p) has been submitted herewith.";
    const othersLabel3 = "A certification statement is not submitted herewith";

    return (
        <div>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#D3D3D3",
                    color: "black",
                    padding: 0
                }}
            >
                <Box/>
                <Box>Form SB-08</Box>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>CERTIFICATION STATEMENT</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={10}>
                            <FormControlLabel name="certificationStatement.isNotSection156" control={<Checkbox className={classes.smallCheckbox} checked={isNotSection156} onChange={handleChange}/>} label={certificationLabel1}/>
                            <br/>
                            <br/>
                            <FormControlLabel name="certificationStatement.isSection156" control={<Checkbox className={classes.smallCheckbox} checked={isSection156} onChange={handleChange}/>} label={certificationLabel2}/>
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
            <Box sx={{
                marginTop: "3%",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: "30vh"
            }}>
                <Paper sx={{flexGrow: 1, display: "flex", flexDirection: "column"}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>
                                <span style={{color: "red"}}>*</span> Other
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={10}>
                            <FormControlLabel name="othersSection.attachedCertification" control={<Checkbox className={classes.smallCheckbox} checked={attachedCertification} onChange={handleChange}/>} label={othersLabel1}/>
                            <br/>
                            <FormControlLabel name="othersSection.feeSubmitted" control={<Checkbox className={classes.smallCheckbox} checked={feeSubmitted} onChange={handleChange}/>} label={othersLabel2}/>
                            <br/>
                            <FormControlLabel name="othersSection.certificationNotSubmitted" control={<Checkbox className={classes.smallCheckbox} checked={certificationNotSubmitted} onChange={handleChange}/>} label={othersLabel3}/>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </div>
    );
};


export default Form_SB_08;